<script lang="ts" setup>
import { getImageFile } from '@/utils';
import { ref } from 'vue';

const emits = defineEmits(['handlePopupResult']);

const show = ref(false);
function showPopup() {
    show.value = true;
}
function hidePopup() {
    show.value = false;
}


defineExpose({
    showPopup,
    hidePopup,
})

</script>
<template>
    <div class="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center z-1000 bg-[rgba(0,0,0,0.5)]" v-show="show">
        <div class="main w-[90%] scale-in-center" v-show="show">
            <img :src="getImageFile('webgl-popup-content.png')" class="w-full object-contain">
            <div class="btn-container w-full mt-4 flex items-center justify-evenly">
                <img :src="getImageFile('confirm.png')" class="object-contain w-40% active:scale-95" @click="hidePopup">
            </div>
        </div>
    </div>
</template>